import { render } from "./AddExerciseSheetQuestionTheme.vue?vue&type=template&id=2fcd0060"
import script from "./AddExerciseSheetQuestionTheme.vue?vue&type=script&lang=js"
export * from "./AddExerciseSheetQuestionTheme.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__